import PropTypes from 'prop-types';
import React from 'react';

class FeedbackThanks extends React.Component {
  render() {
    return (
      <div className="container panel">
        <div className="col-sm-6">
          <h2>Thanks for your help</h2>
          <p>We will investigate and get back to you if required.</p>
        </div>
      </div>
    );
  }
}

export default FeedbackThanks;



// WEBPACK FOOTER //
// src/routes/feedback/components/FeedbackThanks.js